// extracted by mini-css-extract-plugin
export var avatarContainer = "_5b-1";
export var largeAvatarContainer = "_5b-2";
export var smallAvatarContainer = "_5b-0";